var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3200,
    height: 1800,
    viewBox: "0 0 3200 1800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7160_297344)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 300H1875.28V314H1705.39C1702.41 314 1700 310.866 1700 307C1700 303.134 1702.41 300 1705.39 300Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 300H1894.11V314H2069.39V300Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 300H2088.34V314H2266.31V300Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 300H2285.2V314H2460.48V300Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 300H2649.2C2652.18 300 2654.59 303.134 2654.59 307C2654.59 310.866 2652.18 314 2649.2 314H2479.31V300Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 434H1875.28V448H1705.39C1702.41 448 1700 444.866 1700 441C1700 437.134 1702.41 434 1705.39 434Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 434H1894.11V448H2069.39V434Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 434H2088.34V448H2266.31V434Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 434H2285.2V448H2460.48V434Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 434H2649.2C2652.18 434 2654.59 437.134 2654.59 441C2654.59 444.866 2652.18 448 2649.2 448H2479.31V434Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 568H1875.28V582H1705.39C1702.41 582 1700 578.866 1700 575C1700 571.134 1702.41 568 1705.39 568Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 568H1894.11V582H2069.39V568Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 568H2088.34V582H2266.31V568Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 568H2285.2V582H2460.48V568Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 568H2649.2C2652.18 568 2654.59 571.134 2654.59 575C2654.59 578.866 2652.18 582 2649.2 582H2479.31V568Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 702H1875.28V716H1705.39C1702.41 716 1700 712.866 1700 709C1700 705.134 1702.41 702 1705.39 702Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 702H1894.11V716H2069.39V702Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 702H2088.34V716H2266.31V702Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 702H2285.2V716H2460.48V702Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 702H2649.2C2652.18 702 2654.59 705.134 2654.59 709C2654.59 712.866 2652.18 716 2649.2 716H2479.31V702Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 836H1875.28V850H1705.39C1702.41 850 1700 846.866 1700 843C1700 839.134 1702.41 836 1705.39 836Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 836H1894.11V850H2069.39V836Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 836H2088.34V850H2266.31V836Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 836H2285.2V850H2460.48V836Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 836H2649.2C2652.18 836 2654.59 839.134 2654.59 843C2654.59 846.866 2652.18 850 2649.2 850H2479.31V836Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 970H1875.28V984H1705.39C1702.41 984 1700 980.866 1700 977C1700 973.134 1702.41 970 1705.39 970Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 970H1894.11V984H2069.39V970Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 970H2088.34V984H2266.31V970Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 970H2285.2V984H2460.48V970Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 970H2649.2C2652.18 970 2654.59 973.134 2654.59 977C2654.59 980.866 2652.18 984 2649.2 984H2479.31V970Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 1506.01H1875.28V1520.01H1705.39C1702.41 1520.01 1700 1516.87 1700 1513.01C1700 1509.14 1702.41 1506.01 1705.39 1506.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 1506.01H1894.11V1520.01H2069.39V1506.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1506.01H2088.34V1520.01H2266.31V1506.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 1506.01H2285.2V1520.01H2460.48V1506.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 1506.01H2649.2C2652.18 1506.01 2654.59 1509.14 2654.59 1513.01C2654.59 1516.87 2652.18 1520.01 2649.2 1520.01H2479.31V1506.01Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 1104H1875.28V1118H1705.39C1702.41 1118 1700 1114.87 1700 1111C1700 1107.14 1702.41 1104 1705.39 1104Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 1104H1894.11V1118H2069.39V1104Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1104H2088.34V1118H2266.31V1104Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 1104H2285.2V1118H2460.48V1104Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 1104H2649.2C2652.18 1104 2654.59 1107.13 2654.59 1111C2654.59 1114.87 2652.18 1118 2649.2 1118H2479.31V1104Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 1238.01H1875.28V1252.01H1705.39C1702.41 1252.01 1700 1248.87 1700 1245.01C1700 1241.14 1702.41 1238.01 1705.39 1238.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 1238H1894.11V1252H2069.39V1238Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1238H2088.34V1252H2266.31V1238Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 1238H2285.2V1252H2460.48V1238Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 1238H2649.2C2652.18 1238 2654.59 1241.14 2654.59 1245C2654.59 1248.87 2652.18 1252 2649.2 1252H2479.31V1238Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 1372.01H1875.28V1386.01H1705.39C1702.41 1386.01 1700 1382.87 1700 1379.01C1700 1375.14 1702.41 1372.01 1705.39 1372.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 1372.01H1894.11V1386.01H2069.39V1372.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1372.01H2088.34V1386.01H2266.31V1372.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 1372.01H2285.2V1386.01H2460.48V1372.01Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 1372.01H2649.2C2652.18 1372.01 2654.59 1375.14 2654.59 1379.01C2654.59 1382.87 2652.18 1386.01 2649.2 1386.01H2479.31V1372.01Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1057.42 344.398C1085.48 396.701 1082.14 529.372 1045.88 538.72C1031.42 542.448 1000.61 533.316 969.25 514.417L988.93 653.661H872.713L912.719 467.178C890.407 440.988 875.307 408.891 877.83 372.927C885.101 269.298 1029.36 292.095 1057.42 344.398Z",
    fill: "#915B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.408 293.487C1027.02 296.284 1056.13 306.227 1064.39 312.132C1064.39 343.003 1058.4 352.162 1007.31 351.355C994.759 357.984 985.109 369.4 975.058 384.365C979.502 446.335 991.27 477.323 1010.36 477.323C1038.99 477.323 1063.28 459.147 1075.85 459.147C1085 459.147 1082.96 470.607 1076.89 479.104C1071.88 486.115 1047.49 492.872 1047.49 503.74C1047.49 514.609 1066.76 506.2 1066.76 512.646C1066.76 523.308 1070.15 543.355 1051.64 543.355C1032.91 543.355 979.217 536.53 970.014 508.735C964.076 490.797 960.236 453.627 958.495 397.226C957.361 397.084 956.203 397.014 955.03 397.014C938.984 397.014 925.976 410.022 925.976 426.068C925.976 434.214 929.328 441.577 934.728 446.853C928.006 456.342 920.471 466.254 911.838 476.483C879.404 457.024 850.494 395.217 882.203 340.495C890.968 313.688 915.652 304.211 939.086 297.562C958.068 289.622 977.774 288.727 994.408 293.487Z",
    fill: "#2C1B18"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M833.975 1055.58L1011.35 1666.82L1094.79 2125.74H1178.52L1094.93 1055.58H833.975Z",
    fill: "#915B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M833.975 1055.58L1011.35 1666.82L1094.79 2125.74H1178.52L1094.93 1055.58H833.975Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M754.262 1055.58C766.639 1373.11 761.757 1546.3 758.987 1575.15C756.217 1604 740.491 1797.22 633.328 2135.43H720.424C862.344 1810.97 911.887 1617.76 928.164 1575.15C944.441 1532.55 992.514 1359.36 1062.7 1055.58H754.262Z",
    fill: "#915B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M830.162 1055.58C876.301 1265.91 956.103 1601.64 1069.57 2062.79H1192.04C1201.09 1589.47 1162.61 1277.94 1095.96 1055.58H830.162Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M753.637 1055.58C765.758 1373.11 734.344 1685.94 637.035 2067.74H767.713C909.893 1748.12 1011.8 1436.84 1081.44 1055.58H753.637Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M615.918 873.743L721.953 874.141C641.194 1135.79 598.324 1272.79 593.344 1285.13C582.139 1312.9 605.85 1355.19 615.99 1377.92C582.965 1392.7 586.483 1337.97 544.823 1357.35C506.797 1375.04 477.871 1407.1 433.938 1379.99C428.537 1376.65 422.618 1364.11 436.919 1354.3C472.548 1329.87 523.891 1287.11 530.829 1273.04C540.289 1253.85 568.652 1120.75 615.918 873.743ZM1286.7 994.854L1423.87 1128.67C1463.79 1145.7 1496.49 1164.5 1521.98 1185.07C1527.71 1191.98 1533.96 1205.23 1506.98 1199.31C1480.01 1193.38 1451.37 1188.35 1446.3 1197.12C1441.23 1205.9 1456.17 1219.34 1446.8 1230.82C1440.55 1238.47 1419.55 1214.13 1383.78 1157.79L1241.14 1073.69L1286.7 994.854Z",
    fill: "#915B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M939.025 572.945L980.898 565.763C1046.86 798.932 1385.77 957.869 1406.58 1045.03C1414.21 1077 1391.2 1093.16 1403.08 1102.89L1348.66 1142.74C1339.44 1131.98 1319.77 1151.65 1278.7 1137.89C1237.63 1124.13 939.025 849.037 939.025 572.945Z",
    fill: "#8CB4CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M864.548 524.266L994.974 533.386C1005.65 534.132 1013.69 543.388 1012.95 554.059L1009.46 603.668C1004.52 912.596 1183.09 991.351 1143.33 1115.22C1110.51 1217.49 796.328 1327.42 741.961 1227.18C719.951 1186.6 709.967 1137.51 708.836 1084.15C694.944 1125.15 683.953 1160.45 675.868 1190.04C661.922 1241.07 607.857 1249.19 607.857 1268.85L536.628 1249.19C541.459 1222.48 507.88 1209.47 516.883 1149.79C557.224 882.413 665.61 688.597 842.043 568.345L843.875 542.237C844.621 531.565 853.877 523.52 864.548 524.266Z",
    fill: "#9FCBE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7160_297344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 1800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSkills);
export default __webpack_public_path__ + "static/media/custom-skills.0941f0db4282abaf43a7e0d3f3c88c32.svg";
export { ForwardRef as ReactComponent };